module.exports = __webpack_public_path__ + "img/solution3_chart1.bddb65f3.png";